import { Component } from "react";
import { SparkSun } from "@/components/SparkSun";

export class SparkErrorBoundary extends Component {
  state = { failed: false };
  static getDerivedStateFromError() { return { failed: true }; }
  componentDidCatch(err) { console.error("Spark UI error", err); }
  render() {
    if (!this.state.failed) return this.props.children;
    return (
      <div data-testid="spark-error-boundary" className="min-h-screen grid place-items-center px-6" style={{ background: "hsl(var(--spark-canvas))" }}>
        <div className="max-w-md text-center">
          <SparkSun size={64} color="#C3A56B" strokeWidth={1} className="mx-auto" />
          <p className="mt-6 spark-voice text-2xl text-[#17171C] leading-snug">Something interrupted us. Your work is saved.</p>
          <button onClick={() => { this.setState({ failed: false }); window.location.assign("/dashboard"); }} className="spark-btn-primary mt-8">Back to my journey</button>
        </div>
      </div>
    );
  }
}
export default SparkErrorBoundary;
